import { createApp } from "vue";
import VConsole from "vconsole";
import "@/assets/scss/reset.css";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import App from "./App.vue";
import router from "./router";
import "@/utils/flexible.js";
import vant from "vant";
import "vant/lib/index.css";
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
createApp(App).use(pinia).use(vant).use(router).mount("#app");

// 开发环境开启，生产环境自动关闭
if (process.env.NODE_ENV === "development") {
  new VConsole();
}
